import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';

const styles = {
  linkButton: css`
    color: ${theme.colors.primary50};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.large};
  `,
};

type SkipButtonProps = {
  label: string | React.ReactNode;
  onSkip?: () => void;
  id?: string;
};

export function SkipButton({ label, onSkip, id }: SkipButtonProps) {
  const onClick = () => {
    onSkip?.();
  };

  return (
    <div>
      <NakedButton id={id} data-testid={id} css={styles.linkButton} onClick={onClick}>
        {label}
      </NakedButton>
    </div>
  );
}
